import { ApiResponse, query } from './api';
import {
  changeWifiSpotQuery,
  getWifiRoamingStatusQuery,
  getWifiSpotQuery,
  resetWifiSpotPasswordQuery,
} from './wifi-spots.query';
import { IWifiRoamingStatus, WifiSpot, WifiSpotStatus } from './wifi-spots.types';

interface WifiSpotApiInterface {
  getWifiRoamingStatus(billingCustomerId: string, username: string): ApiResponse<IWifiRoamingStatus | null>;
  getWifiSpot(billingCustomerId: string, username: string): ApiResponse<WifiSpot>;
  patchWifiSpot(billingCustomerId: string, username: string, args?: WifiSpotStatus): ApiResponse<WifiSpot>;
  resetWifiSpotPassword(billingCustomerId: string, username: string): ApiResponse<WifiSpot>;
}

export const WifiSpotApi: WifiSpotApiInterface = {
  async getWifiRoamingStatus(billingCustomerId: string, username: string): ApiResponse<IWifiRoamingStatus> {
    const { getWifiRoamingStatus } = await query<{ getWifiRoamingStatus: IWifiRoamingStatus }>({
      query: getWifiRoamingStatusQuery,
      variables: { billingCustomerId, username },
      name: 'getWifiRoamingStatus',
    });
    return { data: getWifiRoamingStatus as IWifiRoamingStatus };
  },

  async getWifiSpot(billingCustomerId: string, username: string): ApiResponse<WifiSpot> {
    const { getWifiSpot } = await query<{ getWifiSpot: WifiSpot }>({
      query: getWifiSpotQuery,
      variables: { billingCustomerId, username },
      name: 'getWifiSpot',
    });
    return { data: getWifiSpot as WifiSpot };
  },
  async patchWifiSpot(billingCustomerId: string, username: string, args?: WifiSpotStatus): ApiResponse<WifiSpot> {
    const { patchWifiSpot } = await query<{ patchWifiSpot: WifiSpot }>({
      query: changeWifiSpotQuery,
      variables: { billingCustomerId, ...args, username },
      name: 'patchWifiSpot',
    });
    return { data: patchWifiSpot as WifiSpot };
  },
  async resetWifiSpotPassword(billingCustomerId: string, username: string): ApiResponse<WifiSpot> {
    const { resetWifiSpotPassword } = await query<{ resetWifiSpotPassword: WifiSpot }>({
      query: resetWifiSpotPasswordQuery,
      variables: { billingCustomerId, username },
      name: 'resetWifiSpotPassword',
    });
    return { data: resetWifiSpotPassword as WifiSpot };
  },
};
